<template>
    <div class="center_img">
    <img src="http://ww1.sinaimg.cn/large/70bfbc22gy1g1g1g4ra6dj207a063408.jpg" />
    <br>
     <br>
    <a-button type="primary" @click="go_home">首页</a-button>
    </div>
</template>

<script>
export default {
    methods:{
        go_home(){
            this.$router.push({
                path: "index"
            });
        }
    }
};
</script>

<style scoped>
.center_img{
    text-align: center;
}
</style>